<template>
  <v-content class="expert-content" id="expert-version-content" role="tabpanel" aria-label="선택한 버전의 분석 화면">
    <!-- style="position: relative;height: 100vh;" -->    
    <v-card 
      style=height:100%
      flat
      tile
    >
      <keep-alive include="NativeEntry"><router-view /></keep-alive>
    </v-card>
  </v-content>
</template>


<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState(['drawer'])  
  },
  methods: {
    ...mapMutations([
      'showDrawer'
    ])
  }  
}
</script>
